/**
 * Modern Results Components
 *
 * Two-tier results display system with consistent Y2K + Glassmorphism styling.
 *
 * Phase 3: Mobile Results Optimization (2025-12-14)
 * - Sections extracted to ./sections/ for modularity
 * - Hooks extracted to ./hooks/ for reusability
 * - QuickNav navigation added to ./navigation/ (Phase 3.2)
 * - Ready for truncation (3.3), accordions (3.4)
 *
 * Components:
 * - ModernResultsPreview: Compact display for Free/Anonymous (L1)
 * - ModernResultsFull: Comprehensive display orchestrator for Pro tiers (L2/L3)
 * - ModernScoreCard: Shared gradient score card component
 *
 * Usage:
 * ```tsx
 * // In index.tsx (unified home, formerly analyze-unified.tsx)
 * {currentTier === "anonymous" || currentTier === "free" ? (
 *   <ModernResultsPreview analysis={data} onNewAnalysis={handleNew} t={t} />
 * ) : (
 *   <ModernResultsFull
 *     analysis={data}
 *     context={context}
 *     tierLevel={tierLevel}
 *     onNewAnalysis={handleNew}
 *     t={t}
 *   />
 * )}
 * ```
 */

// Main components
export { ModernResultsPreview } from "./ModernResultsPreview";
export { ModernResultsFull } from "./ModernResultsFull";
export { DDGenerativeResults } from "./DDGenerativeResults";
export { ModernScoreCard } from "./ModernScoreCard";
export { NarratorFloatingPill } from "./NarratorFloatingPill";
export { NarratorReactionCard } from "./NarratorReactionCard";
export type { NarratorReactionCardProps } from "./NarratorReactionCard";

// Shared styles
export {
  sharedStyles,
  CATEGORY_STYLES,
  SEVERITY_COLORS,
  getCategoryFromScore,
} from "./sharedStyles";

// Section components (for direct access if needed)
export * from "./sections";

// Navigation components (Phase 3.2)
export * from "./navigation";

// Hooks (for custom implementations)
export * from "./hooks";

// Inline Annotations (Priority C: Convert Prototype to Staging)
export * from "./inline-annotations";
